
const useGetMetaDataValue = () => {
  // A meta Data begin always with "source_"
  const findMetaDataVariable = (metaDataType: string,source:any) => {
    const metaDataToFind = source.metadonnees.find(
      (i: any) => i.nom === metaDataType
    )?.valeur;
    if (metaDataToFind) return metaDataToFind;
    return "";
  };

  return {
    findMetaDataVariable,
  };
};

export default useGetMetaDataValue;
